import { type LucideIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// ----------------------------------------------------------------------------

interface EmptyStateProps {
  className?: string;
  icon: LucideIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  iconClassName?: string;
}

export function EmptyState(props: EmptyStateProps) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    className,
    icon: Icon,
    title,
    description,
    actionLabel,
    onAction,
    iconClassName,
  } = props;

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const canRenderAction = Boolean(actionLabel && onAction);

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200 bg-white px-6 py-10 text-center",
        className,
      )}
    >
      <div
        className={cn(
          "mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100 text-gray-500",
          iconClassName,
        )}
      >
        <Icon className="h-7 w-7" />
      </div>

      <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-gray-500">{description}</p>

      {canRenderAction && (
        <Button
          className="mt-6 bg-[#0D6EFD] text-white hover:bg-blue-700"
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
